import React, { useEffect } from "react";
import { AdsGETApiAuth } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";

export default function ExamQuestionModal(props) {
  const {
    setExamName,
    ExamId, setExamID, setExamModal
  } = props;
  const [reload, setReload] = React.useState(false)
  const [Projects1, setProjects1] = React.useState([])
  const [searchExamID, setSearchExamID] = React.useState("")
  const [searchExamName, setSearchExamName] = React.useState("")
  const [ExamType, setExamType] = React.useState("UBT")

  const [UserArray, setUserArray] = React.useState([])
  const GetAllProjects = (params, slug) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slug)
      .then((res) => {
        setProjects1(res.data.filter(a => a.meta.exam_type == "UBT"))
        setUserArray(res.data)
      })
      .catch(err => {
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects({
      per_page: 500,
      _fields: "id,title,slug,meta.available_unavailable,meta.exam_type"
    }, slugs.db_slug_paid_exam)
  }, [])
  return (
    <div>
      <div className="row">
        <div className="col-1" />
        <input className="col-2" style={{ margin: "1px 2px", padding: "3px 2px" }}
          value={searchExamID} placeholder="Exam ID"
          onChange={(event) => {
            setSearchExamID(event.target.value)
            setProjects1(UserArray.filter(a => a.id.includes(event.target.value)))
          }}
        />
        <input className="col-2" style={{ margin: "1px 2px", padding: "3px 2px" }}
          value={searchExamName} placeholder="Exam Name"
          onChange={(event) => {
            setSearchExamName(event.target.value)
            setProjects1(UserArray.filter(a => a.title.rendered.toLowerCase().includes(event.target.value.toLowerCase())))
          }}
        />
        <span className="col-2" style={{ cursor: "pointer" }}
          onClick={() => {
            setProjects1(UserArray.filter(a => a.meta.exam_type == "UBT"))
          }}>
          UBT
        </span>
        <span className="col-2" style={{ cursor: "pointer" }}
          onClick={() => {
            setProjects1(UserArray.filter(a => a.meta.exam_type == "Chapter"))
          }}>
          Chapter
        </span>
        <span className="col-2"
          onClick={() => {
            setExamID("")
            setExamName("")
            setExamModal(false)
          }}>
          Clear
        </span>
      </div>
      <table>
        <tbody>
          <tr>

          </tr>
          {Projects1.map((item, index) => (
            <tr key={index} style={{ cursor: "pointer" }}
              onClick={() => {
                setExamID(item.id)
                setExamName(item.title.rendered)
                setExamModal(false)
              }}>
              <>
                <td>
                  {item.id == ExamId ?
                    <i className="fa fa-check-square-o" />
                    :
                    <i className="fa fa-square-o" />
                  }
                </td>
                <td>{item.id}</td>
                <td>{item.title.rendered}</td>
                <td>{item.meta.available_unavailable}</td>
                {/* <td>{item.meta.exam_type}</td> */}
                <td >Choose</td>
              </>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}